import { cloneDeep } from 'lodash-es';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import {
  cheapestVariant,
  isAllProductSoldOut,
  isCustom,
  isSoldOut,
  ProductVariant,
  ProductWithVariantsUI,
  saledPrice
} from 'src/app/shared-lib/domains/product';

export const productSelected$ = (
  product$: Observable<any>,
  _qty: BehaviorSubject<number>,
  _variantSelected: BehaviorSubject<ProductVariant>
): Observable<ProductWithVariantsUI> =>
  combineLatest([product$, _qty, _variantSelected]).pipe(
    map(([product, qty, variant]) => {
      let uiProduct: ProductWithVariantsUI = cloneDeep(product) as ProductWithVariantsUI;
      if (!uiProduct) return null;
      uiProduct.variantId = null;
      uiProduct.isCustom = isCustom(product);
      if (product.variantCount) {
        if (!variant) {
          uiProduct = { ...uiProduct, ...cheapestVariant(product.variants) } as ProductWithVariantsUI;
          uiProduct.allowSaleNoStock = false;
          uiProduct.stock = 0;
        } else {
          uiProduct = { ...uiProduct, ...variant, id: product.id, variantId: variant.id } as ProductWithVariantsUI;
          uiProduct.variantId = variant.id;
        }
      }
      //TODO falta acomodar las foto .
      uiProduct.pictureUrl = uiProduct.pictureUrl ?? product.pictureUrl;
      uiProduct.price = saledPrice(uiProduct);
      uiProduct.qty = qty;
      uiProduct.hasVariant = !!product.variantCount;
      //console.log('Antes del error: ----------------------------')
      //console.log('product:', product)
      //console.log('uiProduct:', uiProduct)
      uiProduct.canAdd = !isSoldOut(uiProduct);
      uiProduct.isSoldOut = isAllProductSoldOut(uiProduct);
      // console.log("uiProduct", uiProduct)
      return uiProduct;
    })
  );

export abstract class ProductHandle {
  _qty = new BehaviorSubject<number>(1);
  _variantSelected = new BehaviorSubject<ProductVariant>(null);
  variantSelected$ = this._variantSelected.asObservable();
  slug: string;

  product$: Observable<any>;//=> producto cogido de la BLService de BD
  productSelected$: Observable<ProductWithVariantsUI>;

  constructor() {
  }
}
